import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useCart } from '@/contexts/CartContext';
import type { GiftPromotion, GiftLine } from '@/utils/giftPromotions';

export const GIFT_PROMOTIONS_QUERY_KEY = ['gift-promotions'];

/** Public read of the currently running gift promotions (RLS filters inactive ones). */
export const useGiftPromotions = () => {
  const { data = [], isLoading } = useQuery({
    queryKey: GIFT_PROMOTIONS_QUERY_KEY,
    queryFn: async (): Promise<GiftPromotion[]> => {
      const { data, error } = await supabase
        .from('gift_promotions')
        .select('id, name, min_subtotal, gift_product_id, gift_quantity, discount_percentage, active, starts_at, ends_at')
        .order('min_subtotal', { ascending: true });
      if (error) {
        console.warn('[GIFT PROMO] Failed to load promotions:', error.message);
        return [];
      }
      return (data || []) as GiftPromotion[];
    },
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return { promotions: data, isLoading };
};

/** Gift lines the current cart qualifies for (derived inside CartProvider). */
export const useGiftLines = (): { giftLines: GiftLine[] } => {
  const { giftLines } = useCart();
  return { giftLines };
};
